"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDeprecatedTags = void 0;
/**
 * By default, the SLI metrics library will add the cvent_ prefix to all attributes/tags before sending the data to
 * datadog. To standardise traces and logs throughout different Cvent products, some general guidelines were
 * introduced in order to have consistency regarding tag names.
 * @see https://wiki.cvent.com/pages/viewpage.action?spaceKey=RD&title=Tracing+Standards for the complete list of naming
 * conventions and standard Cvent tags to use.
 * We're going to transform the current data to follow these conventions while also adding the cvent_ prefix to keep
 * backwards compatibility.
 *
 * @param data The data to apply the transformation on
 * @param ignoredTagsList A list of tags (attributes of data) we want to ignore in the transformation. This is
 * usually a list of newly added tags that are not currently being used by the SLIs so there is no need to add the
 * cvent_ prefix to
 * @param deprecatedTraceTagsMap A map that has the deprecated tag as a key and the new tag it should use as a value
 */
var transformDeprecatedTags = function (data, ignoredTagsList, deprecatedTraceTagsMap) {
    if (ignoredTagsList === void 0) { ignoredTagsList = []; }
    var cventPrefix = 'cvent_';
    var dataToReport = {};
    var ignoredTagsSet = new Set(ignoredTagsList);
    // the SLI package was updated so it doesn't add the cvent_ prefix. To keep the backwards compatibility we need to
    // keep both tags for a while
    Object.keys(data).forEach(function (key) {
        if (ignoredTagsSet.has(key)) {
            dataToReport[key] = data[key];
        }
        else if (deprecatedTraceTagsMap[key]) {
            dataToReport[deprecatedTraceTagsMap[key]] = data[key];
            dataToReport["".concat(cventPrefix).concat(key)] = data[key];
        }
        else {
            dataToReport[key] = data[key];
            dataToReport["".concat(cventPrefix).concat(key)] = data[key];
        }
    });
    return dataToReport;
};
exports.transformDeprecatedTags = transformDeprecatedTags;
